module.exports = __webpack_public_path__ + "img/shield-icon.456ef9fd.svg";